module.exports = __webpack_public_path__ + "login/static/img/gfi.ebcaaae1.png";